// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1R7UH","productName":"Table_productName__KSYnS"};